<template lang="es">
<div class="profile">
    <Navigation></Navigation>

    <div class="container add_top_30 add_bottom_30">
        <div class="row">
			
            <div class="col col-lg-3">
                
                <ProfileSidebar></ProfileSidebar>

            </div>
            
            <div class="col-md-12 col-lg-9" v-if="loading" >
                <Loader :show="loading" type="inline"></Loader>
            </div>

			<div class="col-md-12 col-lg-9" v-if="!loading" >
                <div class="container box_general">
                    <div class="header_box">
                        <h2><i class="pe-7s-date"></i>Mis exámenes</h2>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                           
                            <div class="alert alert-secondary" v-if="list.length<=0">
                                Aún no tienes reservas exámenes comprados
                            </div>
                            
                            <div  v-if="list.length>0">
                                

                                <div class="table d-block d-md-none">
                                    <router-link tag="div" class="card card-book mb-3" v-for="item in list" :key="item.id" :to="'clinic-services/'+item.id">
                                        
                                        <div class="card-body">
                                            <div class="badge badge-warning" v-if="item.status=='AWAITING_PAYMENT'">Pendiente de pago</div>
                                            <div class="badge badge-danger" v-if="item.status=='FAILED_PAYMENT'">Pago rechazado</div>
                                            <div class="badge badge-light" v-if="item.status=='REFUNDED_PAYMENT'">Pago devuelto</div>
                                            <div class="badge badge-info" v-if="item.status=='CONFIRMED'">Pendiente de coordinación</div>
                                            <div class="badge badge-success" v-if="item.status=='COORDINATED'">Coordinada</div>
                                            <div class="badge badge-light" v-if="item.status=='DONE'">Realizada</div>
                                            <div class="badge badge-danger" v-if="item.status=='CANCELLED'">Cancelada</div>

                                            <h5>{{item.service.service.name}}</h5>

                                            <!-- <label>DIA:</label>
                                            <h5>{{item.timeslot.datetime | moment("dddd DD [de] MMMM, YYYY") }}</h5>
                                            
                                            <label>HORA:</label>
                                            <h5>{{item.timeslot.datetime | moment("HH:mm") }}</h5> -->

                                            <label>CLINICA:</label>
                                            <h5>{{item.clinic.name}}</h5>
                                            
                                        </div>
                                    </router-link>
                                </div>


                                <div class="d-none d-md-block">
                                    <table class="table">
                                        <tr>
                                            <td>Fecha</td>
                                            <td>Exámen de:</td>
                                            <td>Clínica</td>
                                            <!-- <td>Ubicación</td> -->
                                            <td>Precio</td>
                                            <td>Estado</td>
                                        </tr>
                                        <router-link tag="tr" 
                                            v-for="item in list" :key="item.id" 
                                            :to="'/clinic-services/'+item.id" >
                                            <td>{{item.created_at | moment("DD-MM-YYYY HH:mm") }}</td>
                                            <td>
                                                <span class="text-secondary">{{item.service.service.category.name}}</span><br>
                                                {{item.service.service.name}}

                                            </td>
                                            <td>{{item.clinic.name}}</td>
                                            <!-- <td>{{item.medic.address_business_street}} {{item.medic.address_business_number}}</td> -->
                                            <td>$ {{item.price}}</td>
                                            <td>
                                                <span class="badge badge-warning" v-if="item.status=='AWAITING_PAYMENT'">Pendiente de pago</span>
                                                <span class="badge badge-danger" v-if="item.status=='FAILED_PAYMENT'">Pago rechazado</span>
                                                <span class="badge badge-light" v-if="item.status=='REFUNDED_PAYMENT'">Pago devuelto</span>
                                                <span class="badge badge-info" v-if="item.status=='CONFIRMED'">Pendiente de coordinacion</span>
                                                <span class="badge badge-success" v-if="item.status=='COORDINATED'">Coordinada</span>
                                                <span class="badge badge-light" v-if="item.status=='DONE'">Realizada</span>
                                                <span class="badge badge-danger" v-if="item.status=='CANCELLED'">Cancelada</span>
                                            </td>
                                        </router-link>
                                    </table>
                                </div>


                            </div>
                        </div>
                    </div>    
                </div>

                
            </div>



        </div>
        
    </div>

    <!-- <BookingPreview ref="BookingPreview"></BookingPreview> -->

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'

import Navigation from '@/components/Navigation';
import ProfileSidebar from '@/components/ProfileSidebar';
import Footer from '@/components/Footer';
import Loader from '@/components/Loader';
// import BookingPreview from '@/components/BookingPreview';

export default {
    name: 'ClinicServices',
    metaInfo: {
		title: 'Mis exámenes',
	},
    components: {
        Navigation,
        Footer,
        Loader,
        ProfileSidebar,
        // BookingPreview
    },
    data() {
        return {
            loading:true,
            bookings:[],
            previewPane:{
				show: false,
				data: {
					id:''
				}
			}
        }
	},
	computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
	},
    apollo: {
        me: {
            query: gql`query {
                me{    
                    clinic_services {
                        id
                        code
                        price
                        status
                        user{
                            fullname
                        }
                        clinic{
                            id
                            name
                        }
                        service{
                            service{
                                name
                                category{name}
                            }
                        }
                        created_at
                    }
                }
            }`,
            fetchPolicy: 'no-cache',
            variables(){
                return {
                    count: 10
                }
            },
            result (data) {
                this.list = data.data.me.clinic_services;
                this.loading=false;
            },
        }
    },
    
}
</script>

<style scoped>
table tr{
    cursor: pointer;
}
table tr:hover{
    background-color: #fafafa;
}


.card-book .badge{
    display: block;
    margin-bottom: 6px;
    padding: 6px;
}
.card-book .card-body{
    padding: 1rem;
}
.card-book label{
    font-size: .7rem;
    text-transform: uppercase;
    margin: 0px;
}
.card-book h5{
    font-size:1rem;
    margin-bottom: 2px;
}

</style>
